import axios from "axios";
import cloneDeep from "lodash.clonedeep";
import merge from "lodash.merge";
import { toast } from "react-toastify";
const t = () => null;
export const setErrorHandlerDefaultOptions = (options) => {
  defaultOptions = merge(defaultOptions, options);
};

export const handleUnprocessableEntity = (response, options) => {
  const errors = response.data.errors;

  if (options.setError) {
    const setError = options.setError;
    if (Array.isArray(errors)) {
      errors.forEach(({ key, value }) => {
        setError(key, {
          type: "serverSideError",
          message: value?.[0],
        });
      });
    } else {
      Object.keys(errors).forEach(({ key, value }) => {
        setError(key, {
          type: "serverSideError",
          message: value?.[0],
        });
      });
    }
  }

  if (shouldDisplay(response, options.display)) {
    return toast.error(`${response.data?.message} code: ${response.status}`, {
      theme: "colored",
    });
  }
};

let defaultOptions = {
  display: true,
  statusHandlers: {
    422: handleUnprocessableEntity,
  },
};

export const isAxiosError = (error) => {
  return axios.isAxiosError(error);
};

export const handleStepError = (errors, steps, setActiveStep) => {
  let firstStepWithError = null;

  errors.forEach(({ key, value }) => {
    for (let i = 0; i < steps.length; i++) {
      const { keys, setError } = steps[i];
      if (keys.includes(key)) {
        setError(key, {
          type: "serverSideError",
          message: value?.[0],
        });
        if (firstStepWithError === null) {
          firstStepWithError = i;
        }
      }
      if (steps[0].keys.includes(key)) {
        firstStepWithError = 0;
      }
    }
  });

  if (firstStepWithError !== null) {
    setActiveStep(firstStepWithError);
  }
};

export const handleError = (error, options = {}) => {
  const mergedOptions = merge(defaultOptions, cloneDeep(options));
  const serverResponse = error.response;

  if (serverResponse) {
    handleErrorResponse(serverResponse, mergedOptions);
  } else {
    handleErrorRequest();
  }
};

export const handleErrorRequest = () => {
  toast.error(t("Please check your internet connectivity"), {
    theme: "colored",
  });
};

export const handleErrorResponse = (response, options) => {
  const status = response.status;
  const statusHandler = options.statusHandlers[status];

  if (statusHandler && typeof statusHandler === "function") {
    return statusHandler(response, options);
  }

  if (status === 401) {
    return;
  }

  if (status >= 400 && status <= 499) {
    return handleClientError(response, options, status);
  }

  if (status >= 500 && status <= 599) {
    return handleServerError(response, options, status);
  }
};

const handleClientError = (response, options, status) => {
  let message = response.data.message;

  if (shouldDisplay(response, options.display) === false) {
    return;
  }

  if (message) {
    return toast.error(`${message} code: ${status}`, { theme: "colored" });
  } else {
    return toast.error(
      `${t(
        "The service is unavailable now. Please try again later"
      )} code: ${status}`,
      {
        theme: "colored",
      }
    );
  }
};

const handleServerError = (response, options, status) => {
  if (shouldDisplay(response, options.display)) {
    return toast.error(
      `${t(
        "The service is unavailable now. Please try again later"
      )} code: ${status}`,
      {
        theme: "colored",
      }
    );
  }
};

const shouldDisplay = (response, displayOptions) => {
  const status = response.status;

  if (displayOptions === true) {
    return true;
  }

  if (displayOptions === false) {
    return false;
  }

  if (displayOptions[status] === undefined || displayOptions[status] === true) {
    return true;
  }

  return false;
};
